import { render, staticRenderFns } from "./UnorderedList.vue?vue&type=template&id=b90ed38a&scoped=true&"
import script from "./UnorderedList.vue?vue&type=script&lang=js&"
export * from "./UnorderedList.vue?vue&type=script&lang=js&"
import style0 from "./UnorderedList.vue?vue&type=style&index=0&id=b90ed38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90ed38a",
  null
  
)

export default component.exports